import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Buildings, Lock } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Échec de la connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 px-4" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center text-center mb-10">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-11 h-11 rounded-md bg-blue-600 flex items-center justify-center">
              <Buildings size={24} weight="bold" className="text-white" />
            </div>
            <span className="font-heading text-2xl font-semibold text-white tracking-tight">Certicapitale — Isoconseil</span>
          </div>
          <p className="text-[11px] text-slate-400 leading-relaxed max-w-xs">
            Certificat PEB · Réception PEB chauffage · Certibeau · Audit énergétique PAE · Réception PAC RESCERT
          </p>
        </div>

        <div className="bg-white rounded-lg p-8 shadow-xl">
          <p className="label-eyebrow mb-2">Espace expert</p>
          <h1 className="font-heading text-2xl font-medium tracking-tight mb-6 text-slate-950">Connexion</h1>
          <form onSubmit={submit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" data-testid="login-email-input" value={email}
                onChange={(e) => setEmail(e.target.value)} placeholder="expert@expertiseimmo.be" className="h-11" required />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Mot de passe</Label>
              <Input id="password" type="password" data-testid="login-password-input" value={password}
                onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="h-11" required />
            </div>
            <Button type="submit" data-testid="login-submit-button" disabled={loading}
              className="w-full h-11 bg-blue-600 hover:bg-blue-700">
              <Lock size={18} weight="bold" className="mr-1.5" />
              {loading ? "Connexion…" : "Se connecter"}
            </Button>
          </form>
        </div>
        <button onClick={() => navigate("/")} data-testid="go-to-portal-link"
          className="mt-6 text-sm text-slate-400 hover:text-white transition-colors w-full text-center">
          ← Accès client (télécharger un rapport)
        </button>
      </div>
    </div>
  );
}
